function navigation() {
  window.addEventListener("load", () => {
    document.getElementById("fade").classList.add("show");
  });

  const navItems = Array.from(document.querySelectorAll(".nav-item"));
  const navButtons = Array.from(document.querySelectorAll(".nav-item-button"));
  const desktopNavButtons = navButtons.filter((button) => button.closest(".nav-item"));

  const clearNavState = () => {
    navItems.forEach((item) => item.classList.remove("active"));
    desktopNavButtons.forEach((button) => button.classList.remove("expanded"));
  };

  navButtons.forEach((button) => {
    const navItem = button.closest(".nav-item");

    if (!navItem) {
      return;
    }

    button.addEventListener("click", (event) => {
      event.stopPropagation();
      const isActive = navItem.classList.contains("active");
      clearNavState();

      if (!isActive) {
        navItem.classList.add("active");
        button.classList.add("expanded");
      }
    });
  });

  document.addEventListener("click", (event) => {
    if (!event.target.closest(".nav-item")) {
      clearNavState();
    }
  });

  const burgerOpenButton = document.getElementById("burger-menu-open");
  const burgerCloseButton = document.getElementById("burger-menu-close");
  const navMenu = document.getElementById("mobile-menu");

  // Toggle menu on click
  burgerOpenButton.addEventListener("click", function () {
    navMenu.classList.toggle("active");
  });

  burgerCloseButton.addEventListener("click", function () {
    navMenu.classList.remove("active");
  });

  // toggle mobile product menu
  const productButton = document.getElementById("product-toggle");
  const productMenu = document.getElementById("product-menu");
  productButton.addEventListener("click", function () {
    const isActive = productMenu.classList.toggle("active");
    productButton.classList.toggle("expanded", isActive);
  });
  document.addEventListener("click", function (event) {
    if (!productMenu.contains(event.target) && !productButton.contains(event.target)) {
      productMenu.classList.remove("active");
      productButton.classList.remove("expanded");
    }
  });

  // toggle mobile solution menu
  const solutionButton = document.getElementById("solution-toggle");
  const solutionMenu = document.getElementById("solution-menu");
  solutionButton.addEventListener("click", function () {
    const isActive = solutionMenu.classList.toggle("active");
    solutionButton.classList.toggle("expanded", isActive);
  });
  document.addEventListener("click", function (event) {
    if (!solutionMenu.contains(event.target) && !solutionButton.contains(event.target)) {
      solutionMenu.classList.remove("active");
      solutionButton.classList.remove("expanded");
    }
  });

  // toggle mobile solution menu
  const resourceButton = document.getElementById("resource-toggle");
  const resourceMenu = document.getElementById("resource-menu");
  resourceButton.addEventListener("click", function () {
    const isActive = resourceMenu.classList.toggle("active");
    resourceButton.classList.toggle("expanded", isActive);
  });
  document.addEventListener("click", function (event) {
    if (!resourceMenu.contains(event.target) && !resourceButton.contains(event.target)) {
      resourceMenu.classList.remove("active");
      resourceButton.classList.remove("expanded");
    }
  });
}
